<template>
  <b-container>
    <b-row>
      <b-col class="px-0">
        <b-card
          v-if="config"
          no-body
          header="Images"
          class="mt-0">
          <b-card-body>
            <b-form>
              <logo-upload
                ref="light"
                v-model="config.wordmarks.svgLight"
                :can-edit="canBrandingEdit"
                label="Light"
                ref-id="light">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Light"
                    :description="config.wordmarks.rasterLight" />
                </template>
              </logo-upload>
              <hr>
              <logo-upload
                ref="dark"
                v-model="config.wordmarks.svgDark"
                :can-edit="canBrandingEdit"
                label="Dark"
                ref-id="dark">
                <template #additional-label>
                  <b-form-group
                    label="Rasterized Dark"
                    :description="config.wordmarks.rasterDark" />
                </template>
              </logo-upload>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {mapGetters} from "vuex"
  import LogoUpload from "./LogoUpload"

  export default {
    name: "WordmarksForm",
    components: {
      LogoUpload,
    },
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters([
          "canBrandingEdit",
      ]),
      config: {
        get: function () {
          if (!this.value.wordmarks) {
            return {
              wordmarks: {},
            }
          }
          return this.value
        },
        set: function (value) {
          this.$emit("input", value)
        },
      },
      isDisabled() {
        return !this.canBrandingEdit
      },
    },
    watch: {
      'config.wordmarks.svgLight'(newValue) {
        if (newValue) {
          this.config.wordmarks.rasterLight = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
        }
      },
      'config.wordmarks.svgDark'(newValue) {
        if (newValue) {
          this.config.wordmarks.rasterDark = newValue.replace(/\/oms\//, "/f_{type},w_{width}/oms/")
        }
      },
    },
  }
</script>

<style scoped>

</style>
